module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAGFBMVEUAAAD///////////////////////////8jfp1fAAAAB3RSTlMAQFWAE78G08gc3wAAADxJREFUCNdjYGAQBAIGIGAuB4IAIIPdIEmNsQDEEFAvgjIYGChiOLBAGCLl5Y4QESUlZhCDFWSpAQPcGQDn3g4mxfYujQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/Bottom/img1.png
// module id = VXqX
// module chunks = 41